export default {
    createExamSubjectQuestions: '/examSubjectAndQuestions/createExamSubjectQuestions',
    generateExamQuestionsExcel: '/excel/examQuestionsExcel/generateExamQuestionsExcel',
    parseExcel: '/excel/examQuestionsExcel/parseExcel',
    getExamSubjectQuestions: '/examSubjectAndQuestions/getExamSubjectQuestions',
    getExamMultipleSubjectQuestions: '/examSubjectAndQuestions/getExamMultipleSubjectQuestions'
}
